import { useEffect, useState } from "react";
import { Box, Heading, Text, Spinner, VStack } from "@chakra-ui/react";
import { useNavigate, useParams } from "react-router-dom";
import { AdminLayout } from "@/components/layout/AdminLayout";
import { RoleForm } from "@/components/forms/RoleForm";
import { useThemeColors } from "@/hooks/useThemeColors";

export default function EditRolePage() {
  const colors = useThemeColors();
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const roleId = id ? Number(id) : undefined;
  const [isValidating, setIsValidating] = useState(true);

  useEffect(() => {
    if (!roleId || Number.isNaN(roleId)) {
      navigate("/user-management/roles", { replace: true });
    } else {
      setIsValidating(false);
    }
  }, [roleId, navigate]);

  const handleSuccess = () => {
    navigate("/user-management/roles");
  };

  const handleCancel = () => {
    navigate("/user-management/roles");
  };

  if (isValidating || !roleId) {
    return (
      <AdminLayout>
        <Box bg="#FEFCF8" minH="100vh" p={4}>
          <VStack spacing={4} py={8} align="center">
            <Spinner size="xl" color="orange.500" />
            <Text>Loading...</Text>
          </VStack>
        </Box>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      <Box bg="#FEFCF8" minH="100vh" p={4}>
        <VStack spacing={4} align="stretch" flex="1" minH="100vh">
          {/* Header Section */}
          <Box>
            <Heading size="md">Edit Role</Heading>
            <Text fontSize="sm" color={colors.text} mt={1}>
              Update role information and permissions
            </Text>
          </Box>

          {/* Form Section */}
          <Box flex="1" overflow="auto">
            <RoleForm
              roleId={roleId}
              onSuccess={handleSuccess}
              onCancel={handleCancel}
            />
          </Box>
        </VStack>
      </Box>
    </AdminLayout>
  );
}
